import React from 'react';

export default function Help() {
  return (
    <svg viewBox="0 0 36 36" xmlns = "http://www.w3.org/2000/svg">
      <path d="M18 2a16 16 0 1 0 16 16A16 16 0 0 0 18 2Zm-.22 25.85a1.65 1.65 0 1 1 1.65-1.65 1.65 1.65 0 0 1-1.65 1.65Zm1.37-8.06v1.72a1.37 1.37 0 0 1-1.3 1.36h-.11a1.34 1.34 0 0 1-1.39-1.3v-2.76a1.19 1.19 0 0 1 1.12-1.31c1.57-.12 4.18-.7 4.18-3.25 0-1.83-1.41-3.07-3.43-3.07a5.31 5.31 0 0 0-4 1.92 1.36 1.36 0 0 1-2.35-.9 1.43 1.43 0 0 1 .43-1 7.77 7.77 0 0 1 6-2.69c3.7 0 6.28 2.3 6.28 5.6 0 3.05-1.97 5.09-5.43 5.68Z" />
      <path fill="none" d="M0 0h36v36H0z"/>
    </svg>
  );
}